import clsx from "clsx";

import { FieldWrapperProps } from "@/types/common";

export const FieldWrapper = (props: FieldWrapperProps) => {
  const { label, className, wrapperClassName, error, children, id } = props;
  return (
    <div className={clsx("w-full", wrapperClassName)}>
      <label
        className={clsx(
          "block text-sm font-medium text-gray-700 mb-2",
          className
        )}
        htmlFor={id}
      >
        {label}
        <div className="mt-1 relative">{children}</div>
      </label>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className="text-sm font-semibold text-red-500"
        >
          {error.message}
        </div>
      )}
    </div>
  );
};
